module.exports = __webpack_public_path__ + "img/cart-reminder-yt-cover-wa-app.324ef1a1.png";